import * as yup from 'yup';

export const zipCode = yup
	.string()
	.required('Påkrævet')
	.matches(/^\d+$/, 'Skal kun være tal')
	.min(4, '4 cifre forventet')
	.max(4, '4 cifre forventet');
